import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { OPERATION } from '../types/operation.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Operation entity.
 * Stored in 'org/{orgId}/operation'.
 */
export const operationDescriptor = {
    name: OPERATION,
    label: 'Operação',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/operation',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Specific action within a sector',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique operation identifier',
        },
        {
            name: 'code',
            example: 20,
            label: 'Código',
            type: 'number',
            display: 'code',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric operation code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Tingimento em jet',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Operation description',
        },
        {
            name: 'productionInstructions',
            example: 'Carregar jet, adicionar corantes e fixar temperatura',
            label: 'Instruções de produção',
            type: 'string',
            required: false,
            description: 'Production instructions for the operation',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=operation.descriptor.js.map